import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Button } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { HelpCircle } from "lucide-react";
import { useAuditRecordsQuery } from "../api/queries";
import {
  AuditRecordListTour,
  useAuditRecordListTour,
} from "../tour/AuditRecordListTour";
import { AuditRecordFilter } from "../ui/AuditRecordFilter";
import { AuditRecordTable } from "../ui/AuditRecordTable";

export function AuditRecordListPage() {
  const nav = useNavigate({ from: "/app/internal-audit/records" });
  const search: OffsetPageQueryDTO = useSearch({
    from: "/app/internal-audit/records",
  });
  const tour = useAuditRecordListTour();

  const list = useAuditRecordsQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  const canManage = useActionPermission(["internal_audit:create"]);

  const handleView = (id: string) => {
    nav({
      to: "/app/internal-audit/records/$id",
      params: { id },
    });
  };

  return (
    <>
      <Header />

      <Main>
        <AuditRecordListTour
          run={tour.run}
          onCallback={tour.handleJoyrideCallback}
        />
        <div className="mb-4">
          <div
            className="flex items-center justify-between"
            data-tourid="record-toolbar"
          >
            <div>
              <div className="flex items-center space-x-2">
                <h1 className="font-bold text-2xl">ບັນທຶກການກວດສອບ</h1>
                <Button
                  variant="ghost"
                  size="icon"
                  className="size-7 rounded-full"
                  onClick={tour.startTour}
                >
                  <HelpCircle className="size-5" />
                </Button>
              </div>
              <p className="text-muted-foreground">
                ຈັດການບັນທຶກການກວດສອບ (Audit Records).
              </p>
            </div>
            {/* {canManage && (
              <Button
                onClick={() =>
                  nav({
                    to: "/app/internal-audit/records/new",
                    search: {
                      offset: 0,
                      limit: 20,
                      sort: undefined,
                      filters: undefined,
                      planId: undefined,
                    },
                  })
                }
              >
                <PlusIcon className="h-4 w-4" />
                ສ້າງບັນທຶກໃໝ່
              </Button>
            )} */}
          </div>
        </div>

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <AuditRecordFilter />

          <AuditRecordTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({
                search: {
                  offset,
                  limit,
                  sort: search.sort,
                  filters: search.filters,
                },
              })
            }
            sortBy={search.sort ? search.sort[0]?.field : undefined}
            sortOrder={
              search.sort ? (search.sort[0]?.dir as "asc" | "desc") : undefined
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  offset: search.offset ?? 0,
                  limit: search.limit ?? 20,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                  filters: search.filters,
                },
              })
            }
            onView={handleView}
          />
        </div>
      </Main>
    </>
  );
}
